// extracted by mini-css-extract-plugin
export default {"wrapper":"MiniSearch_wrapper__Km8tK"};